import React, { useEffect, useRef, Fragment, useState, useMemo } from 'react';
// @ts-ignore
import OpenSeadragon from 'openseadragon';
import { Box, CircularProgress, css } from '@mui/material';
import queryString from 'query-string';

import { useGetImageForViewer } from '../api/useGetImageForViewer';
import { useSessionStore } from 'session/useSessionStore';

const containerStyle = css({
    width: '100vw',
    height: '100vh',
    '& .image-loading': {
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    '& .image-viewer': {
        width: '100%',
        height: '100%',
        overflow: 'hidden',
    },
});

export function ImageViewer() {
    const viewerRef = useRef<HTMLDivElement>(null);
    const queryParams = queryString.parse(window.location.search);

    const { tenantConfig } = useSessionStore(state => ({
        tenantConfig: state.tenantConfiguration
    }));

    const url = useMemo(() => {
        if (typeof queryParams.fileToken !== 'string') {
            return undefined;
        }
        if (queryParams.source === 'file-manager') {
            return `${tenantConfig?.endpoints.fileManager}/filemanager/filemanager/downloadFile?&fileToken=${queryParams.fileToken}`;
        }
        if (queryParams.source === 'file-indexing') {
            return `${tenantConfig?.endpoints.fileManager}/FileManager/FileManager/GetFileForViewer?fileToken=${queryParams.fileToken}`;
        }
        return undefined;
    }, [tenantConfig, queryParams.source, queryParams.fileToken]);

    const { data, isLoading } = useGetImageForViewer(url);

    useEffect(() => {
        if (viewerRef.current && data) {
            const objectUrl = URL.createObjectURL(data);

            OpenSeadragon({
                element: viewerRef.current,
                prefixUrl: 'https://openseadragon.github.io/openseadragon/images/',
                tileSources: {
                    type: 'image',
                    url: objectUrl,
                },
                showNavigator: true,
                animationTime: 1.5,
                blendTime: 0.1,
                maxZoomPixelRatio: 2,
                minZoomLevel: 0.1,
                maxZoomLevel: 8,
                zoomPerScroll: 2,
                visibilityRatio: 1.0,
                constrainDuringPan: true,
                gestureSettingsMouse: {
                    scrollToZoom: true,
                    clickToZoom: false,
                    dblClickToZoom: true,
                    pinchToZoom: true,
                    flickEnabled: true,
                },
            });
        }
    }, [data]);

    return (
        <Box css={containerStyle}>
            {isLoading ?
                <Box className="image-loading">
                    <CircularProgress />
                </Box> :
                <Box
                    id="openseadragon-viewer"
                    ref={viewerRef}
                    className="image-viewer"
                />
            }
        </Box>
    );
}
